import { render, staticRenderFns } from "./businessUnitPermissions.vue?vue&type=template&id=f4825a30&scoped=true&"
import script from "./businessUnitPermissions.vue?vue&type=script&lang=js&"
export * from "./businessUnitPermissions.vue?vue&type=script&lang=js&"
import style0 from "./businessUnitPermissions.vue?vue&type=style&index=0&id=f4825a30&prod&lang=less&scoped=true&"
import style1 from "./businessUnitPermissions.vue?vue&type=style&index=1&id=f4825a30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4825a30",
  null
  
)

export default component.exports